import ErrorBoundary from '@shared/components/ErrorBoundaries/ErrorBoundary';
import LayoutContainer from '@shared/components/Layout/LayoutContainer';
import CircularLoading from '@shared/components/Loaders/CircularLoading';
import { useAuth } from '@shared/providers/AuthProvider';
import getDependencyHealth, { HealthResponse } from '@shared/services/health-service';
import importRemote from '@shared/utilities/federation/loadremote';
import React, { Suspense, useEffect, useState } from 'react';

import HealthAccordion from './health-accordion';

const services = [
    'attendee/system/health',
    // 'catalog/system/health',
    // 'dealer-management/system/health',
    // 'location/system/health',
];

interface RemoteProps {
    remoteName: string;
    scope: string;
    module?: string;
}

const RemoteWrapper = ({ remoteName, scope, module = './Health' }: RemoteProps) => {
    const RemoteHealthComponent = React.lazy(() =>
        importRemote({
            remoteName,
            scope,
            module,
            bustRemoteEntryCache: true,
        })
    );

    return (
        <ErrorBoundary fallback={<div>Error loading remote: {remoteName}</div>}>
            <Suspense fallback={<CircularLoading />}>
                <RemoteHealthComponent />
            </Suspense>
        </ErrorBoundary>
    );
};

const HealthPage = () => {
    const { getToken } = useAuth();
    const [healths, setHealths] = useState<HealthResponse[]>([]);
    const [loadingServices, setLoadingServices] = useState(true);
    const fetchDependencies = async () => {
        const promises = services.map(svc => {
            return getDependencyHealth(svc, getToken);
        });
        const values = await Promise.all(promises);
        setHealths(values);
        setLoadingServices(false);
    };
    useEffect(() => {
        fetchDependencies();
    }, []);
    const remotes = process.env.REMOTES_LIST ? process.env.REMOTES_LIST.split(',') : [];
    return (
        <LayoutContainer>
            <h3>Remotes:</h3>
            <>
                {remotes.map((r, i) => {
                    const remote = r.replace('_', '');
                    return (
                        <HealthAccordion key={i} healthy={true} title={`Remote: ${remote}`}>
                            <RemoteWrapper
                                remoteName={remote}
                                scope={`remote_${r.toLowerCase()}`}></RemoteWrapper>
                        </HealthAccordion>
                    );
                })}
                <h3>Services</h3>
                {loadingServices ? <div>Loading...</div> : null}
                {healths.map((h, i) => {
                    return (
                        <HealthAccordion key={i} healthy={h.Healthy} title={h.Name}>
                            <div>Total Response Time: {h.ElapsedMs}ms</div>
                            <br />
                            {h.Components.length === 0 ? <div>No components found</div> : null}
                            {h.Components.length > 0 && (
                                <table className="health-table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Resp</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {h.Components.map((c, ci) => {
                                            return (
                                                <tr key={ci}>
                                                    <td>{c.Name}</td>
                                                    <td>{c.Healthy ? 'Healthy' : 'Not Healthy'}</td>
                                                    <td>{c.ElapsedMs}ms</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </HealthAccordion>
                    );
                })}
            </>
        </LayoutContainer>
    );
};

export default HealthPage;
